/* eslint-disable import/no-unresolved */
import * as $ from 'jquery';
import MagicGrid from 'magic-grid';

(() => {
  /**
   * Initialise grid class for each given container element
   *
   * @param {*} blocks
   */
  const initialiseGrid = blocks => {
    blocks.forEach(block => {
      const magicGrid = new MagicGrid({
        container: block,
        gutter: 40,
        static: true, // Required for static content.
        animate: false // Optional.
      });

      magicGrid.listen();
    });
  };

  const postGrid = document.querySelectorAll('.archive-container__items-grid');
  initialiseGrid(postGrid);

  /**
   * Update scripts after Terra is done
   */
  $('body').on('terraDone', (event, $container) => {
    if ($container[0]) {
      const newPostGrid = $container[0].querySelectorAll('.archive-container__items-grid');
      initialiseGrid(newPostGrid);
    }
  });
})();
